export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'FajrFighter',
  title: import.meta.env.VITE_APP_TITLE || 'Fajr Fighter - Wake up for Fajr with community support',
  nameBengali: 'ফজরফাইটার',
  logo: {
    mark: '/fajrfighter-logo.svg',
    lockupOnLight: '/fajrfighter-logo-with-text-onlight.svg',
    lockupInverted: '/fajrfighter-logo-with-text-white.svg'
  },
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  // The Android app. Overridable so a staging build can point at an internal
  // test track rather than the public listing.
  playStoreUrl: import.meta.env.VITE_PLAY_STORE_URL
    || 'https://play.google.com/store/apps/details?id=com.fajrfighter.app',
  description: import.meta.env.VITE_APP_DESCRIPTION || 'Wake up for Fajr with community support',
  author: import.meta.env.VITE_APP_AUTHOR || 'hijam-git',
  contact: {
    email: 'info@fajrfighter.com',
    phone: '+880-1700-000000',
    address: 'ঢাকা, বাংলাদেশ'
  },
  // Environment-based configurations
  env: {
    isDevelopment: import.meta.env.VITE_NODE_ENV === 'development',
    isProduction: import.meta.env.VITE_NODE_ENV === 'production',
    enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info'
  },
  // Feature flags
  features: {
    enableDemoLogin: import.meta.env.VITE_ENABLE_DEMO_LOGIN === 'true',
    enableOtpVerification: import.meta.env.VITE_ENABLE_OTP_VERIFICATION === 'true',
    enableRefreshTokens: import.meta.env.VITE_ENABLE_REFRESH_TOKENS === 'true',
    enablePersistentLogin: import.meta.env.VITE_ENABLE_PERSISTENT_LOGIN === 'true',
    enableAutoLogout: import.meta.env.VITE_ENABLE_AUTO_LOGOUT === 'true',
    enableNotifications: import.meta.env.VITE_ENABLE_NOTIFICATIONS === 'true',
    enablePWA: import.meta.env.VITE_ENABLE_PWA === 'true',
    enableDarkMode: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    enableErrorReporting: import.meta.env.VITE_ENABLE_ERROR_REPORTING === 'true'
  },
  // Default settings
  defaults: {
    country: import.meta.env.VITE_DEFAULT_COUNTRY || 'Bangladesh',
    countryCode: import.meta.env.VITE_DEFAULT_COUNTRY_CODE || '+880',
    timezone: import.meta.env.VITE_DEFAULT_TIMEZONE || 'Asia/Dhaka',
    theme: import.meta.env.VITE_DEFAULT_THEME || 'light',
    language: import.meta.env.VITE_DEFAULT_LANGUAGE || 'en'
  },
  // Supported options
  supported: {
    countries: (import.meta.env.VITE_SUPPORTED_COUNTRIES || 'Bangladesh,Pakistan,India,Malaysia,Indonesia,Saudi Arabia,UAE,Turkey,Egypt,Nigeria,Morocco,Other').split(','),
    languages: (import.meta.env.VITE_SUPPORTED_LANGUAGES || 'en,bn,ar').split(',')
  },
  // Request configuration
  api: {
    timeout: parseInt(import.meta.env.VITE_REQUEST_TIMEOUT) || 10000,
    uploadTimeout: parseInt(import.meta.env.VITE_UPLOAD_TIMEOUT) || 30000,
    retries: 3
  },
  // Storage keys
  storage: {
    accessToken: import.meta.env.VITE_ACCESS_TOKEN_KEY || 'fajr_access_token',
    refreshToken: import.meta.env.VITE_REFRESH_TOKEN_KEY || 'fajr_refresh_token',
    userData: import.meta.env.VITE_USER_DATA_KEY || 'fajr_user_data',
    theme: 'fajr_theme',
    language: 'fajr_language'
  }
}

export const FAQ_DATA = [
  {
    title: 'অলার্ম দেওয়া যায় তো এমন প্রজেক্টের দরকার কি?',
    content: 'অ্যালার্মে যারা সহজে উঠতে পারে তারা অবশ্যই অসাধারণ। কিন্তু অনেকেই অ্যালার্ম বন্ধ করে আবার ঘুমিয়ে যায়। চিন্তা করুন, একজন মুসলিম ভাই নিজের টাকা খরচ করে, সালাম দিয়ে কথা বলে কাউকে ফজরে জাগিয়ে দিলেন—এটি কতটা চমৎকার! এতে শুধু ফজরে ওঠার অভ্যাসই তৈরি হবে না, বরং মুসলিম ভ্রাতৃত্ব ও যোগাযোগ আরও দৃঢ় হবে।\n\nএছাড়া, প্রতিটি ব্যক্তির ট্র্যাকিং থাকবে—কবে উঠলেন, কবে উঠতে পারেননি। ফলে সে নিজের কন্ডিশন দেখতে পাবে এবং ধীরে ধীরে উন্নতি করতে পারবে।'
  },
  {
    title: 'নাম্বার কালেক্ট করে তো কেউ স্প্যাম করতে পারে?',
    content: 'না। এ ধরনের ঝুঁকি এড়ানোর জন্য:\n• প্রতিদিন একজনকে সর্বোচ্চ ৪–৫ টা র‍্যান্ডম নাম্বারই দেখানো হবে।\n• একটি নাম্বার দেখার পর পরবর্তী নাম্বার আসবে ন্যূনতম ৩–৪ মিনিট পর।\n\nফলে কেউ ধারাবাহিকভাবে নাম্বার সংগ্রহ করতে পারবে না।'
  },
  {
    title: 'আমি উঠে গেলে কি আমাকে ফোন দেওয়া হবে?',
    content: 'না। আপনি উঠে গেলে শুধু নিজের স্ট্যাটাস আপডেট করবেন। এতে আমাদের সিস্টেম বুঝতে পারবে এবং আপনার নাম্বার কারো কাছে যাবে না।'
  },
  {
    title: 'যদি কেউ আমাকে কল না দেয়?',
    content: 'এমনটি হতে পারে, তবে আমরা সর্বোচ্চ চেষ্টা করব যাতে কেউ বাদ না যায়। সিস্টেম এমনভাবে তৈরি করা হবে যাতে প্রত্যেকের কাছে অন্তত একজনের কল পৌঁছায়।'
  },
  {
    title: 'আমার নাম্বার কি সবাই দেখতে পাবে?',
    content: 'না। আপনার নাম্বার সবার কাছে দৃশ্যমান হবে না। কেবলমাত্র যে ভাইকে সিস্টেম র‍্যান্ডমভাবে আপনাকে কল করার জন্য বেছে নেবে, সে-ই আপনার নাম্বার দেখতে পাবে।'
  },
  {
    title: 'আমি চাইলে কি ডেট স্কিপ করতে পারি?',
    content: 'হ্যাঁ। আপনি চাইলে যেকোনো দিন স্কিপ করতে পারবেন। স্কিপ করা দিনে আপনাকে ফোন দেওয়া হবে না।'
  },
  {
    title: 'একজনকে দিনে কয়বার ফোন দেওয়া যাবে?',
    content: 'একজনকে দিনে সর্বোচ্চ ২ বার কল দেওয়ার নিয়ম থাকবে। এর বেশি করা যাবে না।'
  },
  {
    title: 'যদি কল রিসিভ না করে বা ব্যস্ত থাকে তাহলে কী হবে?',
    content: 'এক্ষেত্রে আপনি সেই নাম্বারের স্ট্যাটাস (Busy / Off / Not received) দিয়ে দিবেন। তারপর নির্দিষ্ট সময় পর পরবর্তী নাম্বার আসবে।'
  },
  {
    title: 'পয়েন্ট কেন দেওয়া হচ্ছে?',
    content: 'পয়েন্ট সিস্টেম মূলত মোটিভেশন তৈরি করার জন্য।\n• নিজে উঠলে = ৫ পয়েন্ট\n• অন্যকে উঠালে = ১০ পয়েন্ট\n• কল দিলে = ২ পয়েন্ট\n\nপ্রতি মাসে নির্দিষ্ট পয়েন্ট অর্জনকারীরা পুরস্কার পাবেন এবং শীর্ষ ৩ জন পাবেন বিশেষ পুরস্কার।'
  },
  {
    title: 'এই প্রজেক্ট কেন অলাভজনক?',
    content: 'কারণ এর উদ্দেশ্য শুধু মুসলিম উম্মাহকে ফজরে উঠতে সহযোগিতা করা। এটি কোনো ব্যবসায়িক বা আর্থিক লাভের উদ্দেশ্যে নয়, বরং আল্লাহর সন্তুষ্টির জন্য।'
  }
]

export const FEATURES = [
  {
    icon: 'Smartphone',
    title: 'স্মার্ট জাগরণ',
    description: 'AI চালিত স্মার্ট অ্যালার্ম সিস্টেম যা আপনার ঘুমের প্যাটার্ন অনুসরণ করে।'
  },
  {
    icon: 'Users',
    title: 'সামুদায়িক সহায়তা',
    description: 'ইসলামী ভ্রাতৃত্বের বন্ধনে একে অপরকে সাহায্য করুন।'
  },
  {
    icon: 'Shield',
    title: 'নিরাপদ ও বিশ্বস্ত',
    description: 'সম্পূর্ণ নিরাপদ এবং গোপনীয়তা রক্ষাকারী সেবা।'
  },
  {
    icon: 'Globe',
    title: 'বিশ্বব্যাপী নেটওয়ার্ক',
    description: 'বিশ্বের যেকোনো প্রান্ত থেকে সেবা গ্রহণ করুন।'
  },
  {
    icon: 'Clock',
    title: '২৪/৭ সেবা',
    description: 'সব সময় উপলব্ধ এবং নির্ভরযোগ্য সেবা।'
  },
  {
    icon: 'Zap',
    title: 'তাৎক্ষণিক',
    description: 'দ্রুত এবং কার্যকর জাগরণ সিস্টেম।'
  }
]

export const TESTIMONIALS = [
  {
    name: 'আবু বকর',
    location: 'ঢাকা, বাংলাদেশ',
    text: 'আলহামদুলিল্লাহ! এই সেবার মাধ্যমে প্রতিদিন ফজরে উঠতে পারছি।',
    rating: 5
  },
  {
    name: 'আয়েশা খাতুন',
    location: 'লন্ডন, যুক্তরাজ্য',
    text: 'বিদেশে থেকেও ইসলামী ভ্রাতৃত্ব অনুভব করতে পারি।',
    rating: 5
  },
  {
    name: 'মুহাম্মদ আলী',
    location: 'নিউ ইয়র্ক, যুক্তরাষ্ট্র',
    text: 'প্রযুক্তি এবং ইসলামের অপূর্ব মেলবন্ধন।',
    rating: 5
  }
]

export const SPONSORS = [
  {
    name: 'Saba Sanabil Foundation',
    url: 'https://sabasanabil.org',
    description: 'Islamic Foundation'
  },
  {
    name: 'Porda AI',
    url: 'https://pordaai.com',
    description: 'Islamic Content Filter'
  },
  {
    name: 'Music Remover',
    url: 'https://musicremover.org',
    description: 'Remove Music from Videos'
  },
  {
    name: 'Ummah Host BD',
    url: 'https://ummahhostbd.com/',
    description: 'Islamic Web Hosting'
  }
]

export const PAYPAL_ME_URL = 'https://www.paypal.me/IqraWave'
export const DONATION_PRESET_AMOUNTS = [
  { amount: 5,  label: '$5'  },
  { amount: 10, label: '$10' },
  { amount: 25, label: '$25' },
  { amount: 50, label: '$50' },
]

export const HERO_STATS = [
  { icon: 'Users', value: '0', label: 'সক্রিয় সদস্য', key: 'users.total_registered' },
  { icon: 'Phone', value: '0', label: 'মোট কল', key: 'all_time.total_calls' },
  { icon: 'Heart', value: '0', label: 'সফল জাগরণ', key: 'all_time.total_wake_ups' }
]

export const PROFILE_STATS = [
  { icon: 'Phone', label: 'মোট কল', value: '847', color: 'text-blue-500' },
  { icon: 'Clock', label: 'সফল জাগরণ', value: '521', color: 'text-green-500' },
  { icon: 'Award', label: 'পয়েন্ট', value: '12,450', color: 'text-yellow-500' },
  { icon: 'User', label: 'সাহায্য করেছি', value: '156', color: 'text-purple-500' }
]

export const CALL_STATUSES = [
  { id: 'received', icon: 'CheckCircle', label: 'উত্তর দিয়েছে', color: 'text-green-600' },
  { id: 'not_received', icon: 'XCircle', label: 'রিসিভ করেনি', color: 'text-red-600' },
  { id: 'busy', icon: 'PhoneOff', label: 'ব্যস্ত', color: 'text-orange-600' },
  { id: 'invalid', icon: 'PhoneMissed', label: 'ভুল/বন্ধ নাম্বার/স্কিপ করুন', color: 'text-gray-600' },
  { id: 'none', icon: 'Clock', label: 'স্ট্যাটাস আপডেট করেননি', color: 'text-gray-400' }
]

export const NAVIGATION_ITEMS = [
  { name: 'হোম', path: '/', icon: 'House', bengali: 'হোম', key: 'home' },
  { name: 'জাগিয়ে দিন', path: '/wake-up', icon: 'Phone', bengali: 'জাগিয়ে দিন', key: 'wakeUp' },
  { name: 'সালাত সময়', path: '/timetable', icon: 'Clock', bengali: 'সালাত সময়', key: 'timetable' },
  { name: 'কমিউনিটি', path: '/communities', icon: 'Users', bengali: 'কমিউনিটি', key: 'communities' },
  { name: 'প্রোফাইল', path: '/profile', icon: 'User', bengali: 'প্রোফাইল', key: 'profile' }
]